import jsonpatch from 'jsonpatch'
import Schema from './Schema.json'
import migrations from './migrations.mjs'

export default function migrate(frontendData, stage, name) {
  let copiedData = Object.assign({}, frontendData || {})
  const isUpToDate = Schema.version <= copiedData.version
  let nextVersion = (copiedData.version && copiedData.version + 1) || 1

  if (!isUpToDate) {
    for (nextVersion; nextVersion <= Schema.version; nextVersion += 1) {
      let tempData = updateStructure(nextVersion, copiedData)
      copiedData = updateData(nextVersion, tempData, stage, name)
    }
  }

  return { isUpToDate, data: copiedData }
}

export function updateStructure(version, data) {
  if (!migrations[version]) throw new Error('Structure update failed')

  const migration = migrations[version].migration.concat({
    op: 'replace',
    path: '/version',
    value: version,
  })

  return jsonpatch.apply_patch(data, migration)
}

export function updateData(version, data, stage, name) {
  if (!migrations[version]) throw new Error('Data update failed')

  if (!migrations[version].update) {
    return data
  }

  return migrations[version].update && migrations[version].update(data, stage, name)
}



// WEBPACK FOOTER //
// ./src/components/Projects/Form/Frontend/migrate.mjs